import { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Layout, Menu, Button, notification, Card, Row, Col, Typography, Empty } from 'antd'
import { AppstoreOutlined, LogoutOutlined } from '@ant-design/icons'
import { useStoreActions } from 'easy-peasy'
import { useTranslate } from 'hooks/translate'
import Logo from 'pages/Login/image/Pruksa Logo B.png'

const MENU_WIDTH = 200
const THEME = 'light'

export default function LayoutMain ({ children }) {
  const { t } = useTranslate()
  const history = useHistory()

  const [collapsed, setCollapsed] = useState(false)

  const logoutAction = useStoreActions((actions) => actions.auth.logout)
  const menus = JSON.parse(localStorage.getItem('user'))

  const handleLogout = () => {
    logoutAction()
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    notification.error({
      message: 'Logout',
      placement: 'topRight',
    })
    history.push('/')
    window.location.reload()
  }

  return (
    <Layout className='layout-main' style={{ backgroundColor: '#f2f3f7' }}>
      <Layout.Sider
        theme={THEME}
        // width={MENU_WIDTH}
        collapsible
        collapsed={collapsed}
        collapsedWidth='0'
        breakpoint='lg'
        onCollapse={(collapsed) => setCollapsed(collapsed)}
        style={{
          // overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          zIndex: 20,
        }}
      >
        <div className='top'>
          <Row className='logo'>
            <img src={Logo} alt='Logo' style={{ objectFit: 'contain' }} />
          </Row>

          <Menu theme={THEME} mode='inline' style={{ border: 'none' }}>
            {localStorage.getItem('user') &&
              menus?.profile?.menus.map((menu) => {
                return menu.menu_id === 1 ? (
                  <Menu.SubMenu
                    key='incident-management'
                    icon={<AppstoreOutlined />}
                    title={`Incident${'\n'}Management`}
                  >
                    <Menu.Item key='/incident-management/my-incident'>
                      <Link to='/incident-management/my-incident'>My Incident</Link>
                    </Menu.Item>
                    <Menu.Item key='/incident-management/team-incident'>
                      <Link to='/incident-management/team-incident'>Team Incident</Link>
                    </Menu.Item>
                    <Menu.Item key='/incident-management/my-task'>
                      <Link to='/incident-management/my-task'>My Task</Link>
                    </Menu.Item>
                  </Menu.SubMenu>
                ) : menu.menu_id === 2 ? (
                  <Menu.SubMenu key='report-setup' icon={<AppstoreOutlined />} title='Report Setup'>
                    <Menu.Item key='/report-setup/report-type'>
                      <Link to='/report-setup/report-type'>Report Type</Link>
                    </Menu.Item>
                    <Menu.Item key='/report-setup/group-attribute'>
                      <Link to='/report-setup/group-attribute'>Group Attribute</Link>
                    </Menu.Item>
                    <Menu.Item key='/report-setup/report-attribute'>
                      <Link to='/report-setup/report-attribute'>Report Attribute</Link>
                    </Menu.Item>
                    <Menu.Item key='/report-setup/dictionary'>
                      <Link to='/report-setup/dictionary'>Dictionary</Link>
                    </Menu.Item>
                    <Menu.Item key='/report-setup/report-header-attribute'>
                      <Link to='/report-setup/report-header-attribute'>
                        Report Header Attribute
                      </Link>
                    </Menu.Item>
                    <Menu.Item key='/report-setup/risk-level-setup'>
                      <Link to='/report-setup/risk-level-setup'>Risk Level Setup</Link>
                    </Menu.Item>
                  </Menu.SubMenu>
                ) : menu.menu_id === 3 ? (
                  <Menu.SubMenu key='setting' icon={<AppstoreOutlined />} title='Setting'>
                    <Menu.Item key='/setting/organization'>
                      <Link to='/setting/organization'>Organization</Link>
                    </Menu.Item>
                    <Menu.Item key='/setting/profile'>
                      <Link to='/setting/profile'>Profile</Link>
                    </Menu.Item>
                    <Menu.Item key='/setting/user'>
                      <Link to='/setting/user'>User and Role</Link>
                    </Menu.Item>
                  </Menu.SubMenu>
                ) : menu.menu_id === 4 ? (
                  <Menu.SubMenu key='report' icon={<AppstoreOutlined />} title='Report'>
                    <Menu.Item key='/report/monthly-dashboard'>
                      <Link to='/report/monthly-dashboard'>Summary Dashboard</Link>
                    </Menu.Item>
                    <Menu.Item key='/report/monthly-report'>
                      <Link to='/report/monthly-report'>Analysis Report</Link>
                    </Menu.Item>
                    <Menu.Item key='/report/monthly-review'>
                      <Link to='/report/monthly-review'>Monthly Tracking</Link>
                    </Menu.Item>
                    <Menu.Item key='/report/event-tracking'>
                      <Link to='/report/event-tracking'>Audit Log</Link>
                    </Menu.Item>
                  </Menu.SubMenu>
                ) : (
                  ''
                )
              })}
          </Menu>
        </div>

        <div className='bottom'>
          <div className='logout'>
            <Button
              icon={<LogoutOutlined />}
              type='link'
              onClick={handleLogout}
              style={{ color: 'black' }}
            >
              {!collapsed && t('Logout')}
            </Button>
          </div>
        </div>
      </Layout.Sider>

      <Layout className='site-layout' style={{ marginLeft: collapsed ? 0 : 200, paddingTop: 0 }}>
        {menus?.profile ? (
          <Layout.Content>{children}</Layout.Content>
        ) : (
          <Layout.Content>
            <Row justify='center' align='middle' style={{ minHeight: '100%' }}>
              <Col>
                <Card style={{ width: '100%' }}>
                  <Typography.Title
                    level={4}
                    style={{ color: 'dimgray', textAlign: 'center', wordBreak: 'break-word' }}
                  >
                    ไม่พบสิทธิ์ในการใช้งาน โปรดติดต่อ Risk Management Team
                    ในการตั้งค่าสิทธิ์การใช้งาน
                  </Typography.Title>
                  <Empty description={<Typography.Text>No Assigned Profile</Typography.Text>} />
                </Card>
              </Col>
            </Row>
          </Layout.Content>
        )}
      </Layout>
    </Layout>
  )
}
